import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import Weather from "./Weather";
import "./App.css";

export default function App() {
  return (
    <div className="App container">
      <Weather defaultCity="Uzhhorod"/>
      <footer className="mt-2">
              <small> This project was coded by Kateryna Tilishevska
                {" "}and is {" "}
                <a href="https://github.com/kateryna-tilishevska/react-weather" 
                target="_blank" 
                rel="noopener noreferrer">
                open-source code
                 </a>

    </small></footer>
    </div>
  )
  }